import React from "react";
import { RotateCcw } from "lucide-react";
import "./Css/VillageHistory.css";

import ancientImg from "./Images/nali.jpg";
import freedomImg from "./Images/Mandir.jpg";
// import modernImg from "../Images/modern.jpg";

const VillageHistory = () => {
  const historyData = [
    {
      title: "वर्षानुवर्षे तासगावची तहान भागविणार नैसर्गिक झरा वरदान",
      desc: "ह्या फोटो मध्ये जे ईगलु घरासारखे आकाराचे बांधकाम दिसतंय ते एखाद घर नसून निसर्गाचा एक चमत्कार आणि वरदान आहे...",
      image: ancientImg,
    },
    {
      title: "तासगावचे ऐतिहासिक पांडवकालीन सिद्धेश्वर मंदिर",
      desc: "तासगांव हे सातारा जिल्ह्यातील सातारा तालुक्यातील एक सर्वात जुने आणि मुख्य बाजारपेठ असणारे तसेच जास्त लोकसंख्या असणारे गाव आहे गावचा इतिहास असा आहे की या गावात पांडवकालीन सिद्धेश्वराचे मंदिर आहे हे मंदिर पांडव या ठिकाणी वास्तव्यास असताना त्यांचे कार्य सिद्धीस जावे म्हणून त्यांनी एका रात्रीमध्ये हे हेमाडपंथी मंदिर बांधले.आणि कार्य सिद्धीस नेणारा म्हणून सिद्धेश्वर मंदिर म्हणून हे मंदिर प्रसिद्ध झाले. या ठिकाणी जिल्ह्यातून बरेच भाविक येतात आणि महादेवाची भक्ती करतात.",
      image:freedomImg,
    },
   
  ];

  return (
    <section className="village-history">
       
        <h2>गावाचा इतिहास</h2>

      <p className="history-subtitle">
        वर्षानुवर्षांची समृद्ध संस्कृती व परंपरा जाणून घ्या.
      </p>

      <div className="history-cards">
        {historyData.map((item, index) => (
          <div className="history-card" key={index}>
            <img src={item.image} alt={item.title} className="history-img" />
            <div className="history-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VillageHistory;
